var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTransactionDirectDepositReturned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5187 26.1221C9.55571 24.2185 8.38518 21.7267 8.21215 19.085C7.78807 12.8477 12.8923 7.41905 19.6172 6.95485L31.5814 6.92701",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3619 11.7352C31.3259 13.6387 32.4969 16.1304 32.6699 18.7721C33.094 25.0093 27.9896 30.4381 21.2612 30.9026L9.30003 30.9212",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6553 5L32.7547 6.83112L30.9236 8.93045",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2267 32.8572L8.12741 31.0261L9.95853 28.9267",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.441,
    cy: 28,
    r: 6,
    fill: "#DD7200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.004 28.6851L30.6469 25.4709C30.7991 24.7099 30.217 24 29.441 24C28.665 24 28.083 24.7099 28.2352 25.4709L28.8781 28.6851C28.9147 28.8682 29.0754 29 29.2622 29H29.6199C29.8066 29 29.9674 28.8682 30.004 28.6851Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.441 31C29.3034 31 29.1856 30.9511 29.0878 30.8533C28.99 30.7554 28.941 30.6377 28.941 30.5C28.941 30.3623 28.99 30.2446 29.0878 30.1467C29.1856 30.0489 29.3034 30 29.441 30C29.5787 30 29.6965 30.0489 29.7943 30.1467C29.8921 30.2446 29.941 30.3623 29.941 30.5C29.941 30.6377 29.8921 30.7554 29.7943 30.8533C29.6965 30.9511 29.5787 31 29.441 31Z",
    fill: "white",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.441 14.2C18.7842 14.2 17.441 15.2745 17.441 16.6C17.441 17.9255 18.441 19 20.441 19C22.441 19 23.441 20.0745 23.441 21.4C23.441 22.7255 22.0979 23.8 20.4411 23.8M20.441 14.2C21.5514 14.2 22.521 14.6826 23.0397 15.4M20.441 14.2V13M20.4411 23.8L20.441 25M20.4411 23.8C19.3306 23.8 18.3611 23.3174 17.8424 22.6",
    stroke: "#A8B2C8",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransactionDirectDepositReturned);
export default __webpack_public_path__ + "static/media/ic-transaction-direct-deposit-returned.c7f7af8188fb4852fdb104f4432a78c0.svg";
export { ForwardRef as ReactComponent };